import gql from 'graphql-tag';
import apollo from 'src/features/apolloCustomer';
import i18n from 'src/features/i18n';

const mutation = gql`
mutation InitAuth($provider: String!, $providerId: String!){
  initAuth(provider: $provider, providerId: $providerId) {
    id
  }
}`;

function initAuth(type, title) {
  return apollo.client.mutate({
    variables: {
      provider: type,
      providerId: title,
    },
    mutation,
  }).then((res) => res.data.initAuth)
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].message;
        throw i18n.t(errors);
      } else {
        throw err;
      }
    });
}

export default initAuth;
